// 06 · Perfil — paridad completa: plan, mini-stats de por vida, Mi cuenta,
// Configuración (modales existentes reutilizados), notificaciones push,
// Telegram, rangos, Aprende, sesión.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { clearSessionExpiredFlag } from '../../auth/authHelpers';
import useClientStats from '../hooks/useClientStats';
import usePushPermission from '../../hooks/usePushPermission';
import { statsOfSubset } from '../../components/PerformanceLab';
import MiCuentaModal from '../../components/modals/MiCuentaModal';
import ConfiguracionModal from '../../components/modals/ConfiguracionModal';

const Row = ({ icon, title, value, onClick, danger }) => (
  <button className="app-mi" onClick={onClick} style={danger ? { color: 'var(--neg)' } : {}}>
    <span className="ico">{icon}</span>
    <span className="t">{title}</span>
    {value && <span className="val">{value}</span>}
  </button>
);
const Ic = ({ d }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{d}</svg>
);

export default function Profile() {
  const navigate = useNavigate();
  const { user, userData, isAdmin, hasActiveAccess, accessUntil, signOut } = useAuth();
  const { signals } = useClientStats();
  const push = usePushPermission();
  const [openCuenta, setOpenCuenta] = useState(false);
  const [openConfig, setOpenConfig] = useState(false);

  const nombre = userData?.nombre || user?.displayName || (user?.email || '').split('@')[0] || 'Cliente';
  const inicial = nombre.trim().charAt(0).toUpperCase();

  // Stats de por vida — misma fuente (Performance Lab helpers).
  const st = statsOfSubset(signals);
  let u = 0, staked = 0;
  for (const s of signals) {
    const stake = parseFloat(s.stake_u_publicado || 1) || 1;
    if (s.result === 'WIN') { u += stake; staked += stake; }
    else if (s.result === 'LOSS') { u -= stake; staked += stake; }
  }
  const yieldPct = staked > 0 ? (u / staked) * 100 : null;

  const venceStr = accessUntil
    ? new Intl.DateTimeFormat('es-CL', { timeZone: 'America/Santiago', day: 'numeric', month: 'long' })
        .format(accessUntil.seconds ? new Date(accessUntil.seconds * 1000) : new Date(accessUntil))
    : null;
  const legacy = userData?.legacyPricing === true;
  const esSub = !!userData?.flowSubscriptionId || !!userData?.paypal_subscription_id;

  const pushValue = push.status === 'granted' ||
    (typeof Notification !== 'undefined' && Notification.permission === 'granted' && (userData?.pushTokens || []).length > 0)
    ? 'Activadas' : 'Desactivadas';

  const tgVinculado = !!userData?.telegramChatId;

  const cerrar = async () => {
    clearSessionExpiredFlag();
    await signOut();
    navigate('/app', { replace: true });
  };

  return (
    <div className="app-scroll">
      <div className="app-pf-top">
        <div className="app-pf-av">{inicial}</div>
        <div>
          <p className="nm">{nombre}</p>
          <p className="em">{user?.email}</p>
        </div>
      </div>

      <div className="app-hero" style={{ marginBottom: 14 }}><div className="in">
        {isAdmin ? (
          <>
            <p className="v61" style={{ color: '#FF9466' }}>ACCESO COMPLETO</p>
            <h3 style={{ color: '#fff', fontSize: 22, fontWeight: 900, letterSpacing: '-.035em', margin: '7px 0 4px' }}>Cuenta admin</h3>
            <button className="app-cta" style={{ marginTop: 14, background: 'var(--accent)' }} onClick={() => navigate('/admin/dashboard')}>Ir al panel admin →</button>
          </>
        ) : hasActiveAccess ? (
          <>
            <p className="v61" style={{ color: '#FF9466' }}>PLAN ACTIVO</p>
            <h3 style={{ color: '#fff', fontSize: 22, fontWeight: 900, letterSpacing: '-.035em', margin: '7px 0 4px' }}>
              {esSub ? 'Suscripción mensual' : 'Pago único'}
            </h3>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,.5)', lineHeight: 1.45, margin: 0 }}>
              CLP {legacy ? '9.990' : '19.990'}/mes{legacy ? ' · precio fundador' : ''}<br />
              Vence el {venceStr}. Sin permanencia.
            </p>
            <button className="app-cta" style={{ marginTop: 14, background: 'var(--accent)' }} onClick={() => navigate('/checkout')}>Administrar plan</button>
          </>
        ) : (
          <>
            <p className="v61" style={{ color: '#FF9466' }}>SIN PLAN ACTIVO</p>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,.5)', margin: '8px 0 0' }}>Activa tu acceso para recibir todas las señales.</p>
            <button className="app-cta" style={{ marginTop: 14, background: 'var(--accent)' }} onClick={() => navigate('/checkout')}>Activar acceso</button>
          </>
        )}
      </div></div>

      <div className="app-mini">
        <div><p className="v g">{st.winRate != null ? `${st.winRate.toFixed(0)}%` : '—'}</p><p className="l">Acierto</p></div>
        <div><p className="v o">{yieldPct != null ? `${yieldPct > 0 ? '+' : ''}${yieldPct.toFixed(0)}%` : '—'}</p><p className="l">Yield</p></div>
        <div><p className="v">{st.total}</p><p className="l">Señales</p></div>
      </div>

      <p className="app-grp">Cuenta</p>
      <div className="app-menu">
        <Row icon={<Ic d={<><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" /></>} />} title="Mi cuenta" value={null} onClick={() => navigate('/app/cuenta')} />
        <Row icon={<Ic d={<><circle cx="12" cy="12" r="3" /><path d="M12 1v4M12 19v4M4.2 4.2l2.8 2.8M17 17l2.8 2.8M1 12h4M19 12h4M4.2 19.8L7 17M17 7l2.8-2.8" /></>} />} title="Configuración" value={null} onClick={() => setOpenConfig(true)} />
        <Row icon={<Ic d={<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0" />} />} title="Notificaciones" value={pushValue}
          onClick={() => { if (push.needsInstallFirst) navigate('/app/instalar'); else if (push.canRequest || pushValue === 'Desactivadas') push.request(); }} />
        <Row icon={<Ic d={<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />} />} title="Canal de Telegram" value={tgVinculado ? 'Vinculado' : 'Vincular'} onClick={() => navigate('/app/telegram')} />
        <Row icon={<Ic d={<path d="M3 17l5-6 4 4 5-8 4 5" />} />} title="Rangos de referencia" value={null} onClick={() => navigate('/app/rangos')} />
        <Row icon={<Ic d={<><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></>} />} title="Aprende" value={null} onClick={() => navigate('/aprende')} />
        <Row icon={<Ic d={<circle cx="12" cy="12" r="9" />} />} title="Deportes seguidos" value="Básquet · Handball" onClick={() => {}} />
        <Row icon={<Ic d={<><rect x="2" y="5" width="20" height="14" rx="3" /><path d="M2 10h20" /></>} />} title="Medios de pago" value="Webpay · PayPal" onClick={() => navigate('/checkout')} />
        <Row icon={<Ic d={<><circle cx="12" cy="12" r="9" /><path d="M12 16v-4M12 8h.01" /></>} />} title="Ayuda y soporte" value={null} onClick={() => navigate('/soporte')} />
      </div>

      <p className="app-grp">Sesión</p>
      <div className="app-menu">
        <Row icon={<Ic d={<path d="M3 10.5L12 3l9 7.5V21H3z" />} />} title="Volver al dashboard" value={null} onClick={() => navigate('/dashboard')} />
        <Row danger icon={<Ic d={<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5M21 12H9" /></>} />} title="Cerrar sesión" value={null} onClick={cerrar} />
      </div>

      <MiCuentaModal open={openCuenta} onClose={() => setOpenCuenta(false)} />
      <ConfiguracionModal open={openConfig} onClose={() => setOpenConfig(false)} />
    </div>
  );
}
